import BaseGenericEvent from '../../BaseGenericEvent';
import {getSearchEventData, getTravellerDetailsList} from '../../PdtHelper/RailsPdtUtils';
import {RailsPdtConstants} from '../../PdtHelper/RailsPdtConstants';

export default class RailsPdtReviewEvent extends BaseGenericEvent {
  constructor(pdtData) {
    const data = pdtData;
    data.pageName = RailsPdtConstants.FunnelStep.REVIEW;
    data.funnelStep = RailsPdtConstants.FunnelStep.REVIEW;
    super(data);
    this.searchData = pdtData.searchData;
    this.travellerData = pdtData.travellerData;
  }

  trackReviewEvent = () => {
    const basePdtObject = this.basePdtData();
    basePdtObject.rail_search_context = getSearchEventData(this.searchData);
    [basePdtObject.traveller_details_list,basePdtObject.traveller_details_railofy] = getTravellerDetailsList(this.travellerData);
    return basePdtObject;
  }
}
